import { deleteLocalStore } from "../../data/DbStore";
import { deleteSavedState } from "../../store/Store";

export function eraseAll(): void {
  deleteSavedState();
  deleteLocalStore().then(() => location.reload());
}
